import { Modal, ModalActionsProps, ModalContent, ModalContentProps, ModalDescriptionProps, ModalHeaderProps, ModalProps } from "semantic-ui-react";

type BPModalProps = ModalProps & {};

export function BPModal(props: BPModalProps) {
    return <Modal {...props}>{props.children}</Modal>;
}

type BPModalHeaderProps = ModalHeaderProps & {};
export function BPModalHeader(props: BPModalHeaderProps) {
    return <Modal.Header {...props}>{props.children}</Modal.Header>;
}

type BPModalContentProps = ModalContentProps & {};
export function BPModalContent(props: BPModalContentProps) {
    return <ModalContent {...props}>{props.children}</ModalContent>;
}

type BPModalActionsProps = ModalActionsProps & {};
export function BPModalActions(props: BPModalActionsProps) {
    return <Modal.Actions {...props}>{props.children}</Modal.Actions>;
}

type BPModalDescriptionProps = ModalDescriptionProps & {};
export function BPModalDescription(props: BPModalDescriptionProps) {
    return <Modal.Description {...props}>{props.children}</Modal.Description>;
}